import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SNowRequestComponent, SNowRequestDialogComponent } from './components/sNowRequest/snowRequest.component';
import { TEHeaderComponent, HeaderEventService, LanguageDialogComponent } from './components/teHeader/teHeader.component';
import { TEFooterComponent, SdContactDialogComponent, CountryDialogComponent} from './components/teFooter/teFooter.component';
import { EqualValidator } from './components/validateEqual/validateEqual.directive';
import { LocalStorage } from './components/localStorage/localStorage.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Globals } from './components/global/globals';
import { UserInfoService } from '../../Main/services/userInfo/userInfo.service';
import { UserAccessService } from '../../Main/services/userInfo/userAccess.service';
import { PasswordStrengthMeterComponent } from './components/passwordStrengthMeter/password-strength-meter.component';
// AoT requires an exported function for factories
export function httpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, '/Common/i18n/Login/', '.json');  //base href of /Login is throwing this off.. 
}


@NgModule({
    declarations: [
        TEHeaderComponent,
        TEFooterComponent,
        PasswordStrengthMeterComponent,
        SNowRequestComponent,
        SNowRequestDialogComponent,
        LanguageDialogComponent,
        EqualValidator,
        SdContactDialogComponent,
        CountryDialogComponent
    ],
    providers: [
        HeaderEventService,
        LocalStorage, Globals,
        UserInfoService,
        UserAccessService
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatDialogModule,
        MatSelectModule,
        MatMenuModule,
        MatIconModule,
        MatListModule, MatDatepickerModule, MatNativeDateModule, MatCheckboxModule, MatRadioModule,
        MatProgressBarModule, MatProgressSpinnerModule, MatExpansionModule, MatCardModule, MatTableModule, MatGridListModule ,
        MatTooltipModule,
        RouterModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpLoaderFactory,
                deps: [HttpClient]
            }
        }),
       
    ],
    exports: [
        TEHeaderComponent,
        TEFooterComponent,
        PasswordStrengthMeterComponent,
        SNowRequestComponent,
        EqualValidator
    ]
})
export class TeCommonUiModule
{
}
